import React from 'react';
import { useTranslate } from 'ra-core';
import { useFeedWidgetsData } from '../../../api/hooks/useFeedWidgetsData';
import { Widget } from '../Widget';

interface FeedWidgetsProps {
  after: string;
  before: string;
}

export const FeedWidgets: React.FC<FeedWidgetsProps> = ({ after, before }) => {
  const translate = useTranslate();
  const { data } = useFeedWidgetsData({ after, before });

  const { posts, comments, reactions } = data ?? {
    posts: { total: 0, lastSevenDays: 0 },
    comments: { total: 0, lastSevenDays: 0 },
    reactions: { total: 0, lastSevenDays: 0 },
  };

  const previousSevenDays = (count: number) =>
    translate('moonstar.dashboard.feed.previousSevenDays', { count });

  return (
    <div className="mb-4 mt-0 grid grid-cols-1 gap-4 md:grid-cols-3">
      <div>
        <Widget
          title={translate('moonstar.dashboard.feed.widgets.posts.title')}
          textPrimary={posts.total.toString()}
          textSecondary={previousSevenDays(posts.lastSevenDays)}
          description={translate(
            'moonstar.dashboard.feed.widgets.posts.description'
          )}
        />
      </div>
      <div>
        <Widget
          title={translate('moonstar.dashboard.feed.widgets.comments.title')}
          textPrimary={comments.total.toString()}
          textSecondary={previousSevenDays(comments.lastSevenDays)}
          description={translate(
            'moonstar.dashboard.feed.widgets.comments.description'
          )}
        />
      </div>
      <div>
        <Widget
          title={translate('moonstar.dashboard.feed.widgets.reactions.title')}
          textPrimary={reactions.total.toString()}
          textSecondary={previousSevenDays(reactions.lastSevenDays)}
          description={translate(
            'moonstar.dashboard.feed.widgets.reactions.description'
          )}
        />
      </div>
    </div>
  );
};
